import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const TripColumns: TableColumn[] = [
    {
        name: "billOfLading", 
        displayName: "BOL", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "containerQuantity", 
        displayName: "#", 
        dataType: COLUMN_TYPES.number, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "totalRate", 
        displayName: "Rate", 
        dataType: COLUMN_TYPES.currency, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "client", 
        displayName: "Client", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "shippingLine", 
        displayName: "Shipping Line", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "isActive", 
        displayName: "Is Active?", 
        dataType: COLUMN_TYPES.bool, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {'text-align': 'center'},
        reference: '',
        selectOptions: null
    },
    {
        name: "tripStatus", 
        displayName: "Status", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "paymentStatus", 
        displayName: "Payment Status", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "createdBy", 
        displayName: "Created By", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    },
    {
        name: "createdDate", 
        displayName: "Created On", 
        dataType: COLUMN_TYPES.date, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    }
]


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.trip.ts